import './NoStudentsMessage.scss';

import * as React from 'react';

import { escape as escapeHtml } from 'lodash';

import { FeatureUseEventAdapter } from '~analytics/adapters/FeatureUseEventAdapter';
import { translate } from '~l10n/client';
import { UIButton } from '~shared/components/buttons';
import { useInviteStudentsDrawerDispatch } from '~teacher/components/ActivityResult/modals/InviteStudentDrawer/InviteStudentDrawerContext';

interface Props {
  roomName: string;
}

export function NoStudentsMessage({ roomName }: Props) {
  const dispatch = useInviteStudentsDrawerDispatch();
  const openInviteStudentsDrawer = () => {
    new FeatureUseEventAdapter({
      feature: 'invite_student_drawer',
      action: 'open',
      source: 'activity_results_body',
    }).sendAnalytics();

    dispatch('Open');
  };

  return (
    <div className="w-screen">
      <div className="sticky left-0 -mr-8 -ml-8 pb-12  bg-white legacy-container grid grid-cols-1 gap-6 justify-center ">
        <div className="mx-auto">
          <span
            className="font-display leading-7 text-md text-500 font-display"
            dangerouslySetInnerHTML={{
              __html: translate(
                'Waiting for Students to Join <span class=\"room-link-name\">{0}</span>' /* eslint-disable-line */ /* prettier-ignore */
              ).format(escapeHtml(roomName)),
            }}
          />
        </div>
        <div className="mx-auto font-sans text-400 leading-6 text-base font-sans">
          <UIButton
            appearance="primary"
            data-testid="invite-students-button"
            onClick={openInviteStudentsDrawer}
          >
            {translate('Invite Students')}
          </UIButton>
        </div>
      </div>
    </div>
  );
}
